import { LicenseManager } from "ag-grid-enterprise";
import { getGlobalConfig } from "src/datahandling/redux/globalConfig";

export function registerAgGridLicense(): void {
	const gc = getGlobalConfig();
	if (!gc) return; // Config not yet loaded
	const licenseKey = gc.AG_GRID;
	if (licenseKey) {
		LicenseManager.setLicenseKey(licenseKey);
	}
}
